const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../views/LoginView.vue"),
    meta: { requiresAuth: false },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/DashView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/company",
    name: "Company",
    component: () => import("../views/Masters/CompanyAdd.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("../views/Masters/UsersList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/userroles",
    name: "UserRoles",
    component: () => import("../views/Masters/UsersRoleList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/vehicles",
    name: "Vehicles",
    component: () => import("../views/Masters/VehicleList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/vendors",
    name: "Vendors",
    component: () => import("../views/Masters/VendorsList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/groups",
    name: "Groups",
    component: () => import("../views/Masters/GroupList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/prodmst",
    name: "Product",
    component: () => import("../views/Masters/prodList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/coms",
    name: "Coms",
    component: () => import("../views/Masters/CcPorts.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/po",
    name: "P.O",
    component: () => import("../views/Transactions/PoList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/tokenlab",
    name: "TokenLab",
    component: () => import("../views/Transactions/TokenlabList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/token",
    name: "Token/GatePass",
    component: () => import("../views/Transactions/TokenList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/milkrec",
    name: "MilkReceipt",
    component: () => import("../views/Transactions/WeighmentAdd.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/labafterwht",
    name: "LabAfterWHT",
    component: () => import("../views/Transactions/LabafterWht.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/labent",
    name: "LabEntry",
    component: () => import("../views/Transactions/LabEntry.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/whtreport",
    name: "WeighmentReport",
    component: () => import("@/views/Reports/WeighmentReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/gateoutreport",
    name: "GateOutReport",
    component: () => import("@/views/Reports/GateOut.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/porep",
    name: "LabEntryAfterWeighmentReport",
    component: () => import("@/views/Reports/PoReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/tokenrep",
    name: "TokenReport",
    component: () => import("@/views/Reports/TokenReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/labrep",
    name: "LabReport",
    component: () => import("@/views/Reports/LabReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/labrepqa",
    name: "LabReportQa",
    component: () => import("@/views/Reports/LabReportQa.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cleardata",
    name: "ClearData",
    component: () => import("@/views/ClearData.vue"),
    meta: { requiresAuth: true },
  },
];

export default routes;
